import {
    isRouteErrorResponse,
    Links,
    Meta,
    Outlet,
    Scripts,
    ScrollRestoration,
    useNavigation
} from "react-router";
import CircularProgress from '@mui/material/CircularProgress';

import { useContext } from 'react';

import SearchContext, {SearchProvider} from 'src/context/SearchContext';
import Header from 'src/components/Header';
import Footer from 'src/components/Footer';
import { headers } from 'src/util/Util';

import 'src/assets/fonts/iconos/iconos.css';
import 'src/assets/fonts/Barlow/stylesheet.css';
import 'src/assets/fonts/Oswald/styleOswald.css';
import "src/css/main.scss";

const ITEMS_EP = import.meta.env.VITE_ITEMS_EP;
const BASE_URL = import.meta.env.VITE_BASE_URL || '/';
const PROD = import.meta.env.PROD;

export function meta() {
    return [
        { title: "Microscopía Virtual" },
        { name: "description", content: "Microscopía virtual y recursos para estudios de la salud" },
    ];
}

export const links = () => [
    { rel: "preconnect", href: "https://fonts.googleapis.com" },
    {
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossOrigin: "anonymous",
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600&display=swap',
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600&display=swap',
    },
    {
        rel: "stylesheet",
        href: 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;600&display=swap',
    },
    {
        rel: "icon",
        href: BASE_URL + 'favicon.svg',
        type: 'image/svg+xml'
    },
];

export async function clientLoader({ request, params }) {
    let body = {
        "aggs": {
            "unique_subject": {
                "terms": {
                    "field": "metadata.dc_subject.keyword",
                    "size": 1500
                }
            }
        },
        "fields": [
            "metadata.dc_subject"
        ],
        "_source": false,
        "size": 0
    };

    let url = `${ITEMS_EP}_search`;
    try {
        let docs = await (await fetch(url, {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
        }))?.json()
        // console.log('cargando temas...');
        let temas = docs?.aggregations.unique_subject.buckets;
        // console.log('temas cargados', temas.length);
        return { temas };
    } catch (e) {
        /* handle error */
        console.log(e);
    }
}

export function Layout({ children }) {
    return (
        <html lang="en">
            <head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <Meta />
                <Links />
            </head>
            <body>
                <SearchProvider>
                    {children}
                </SearchProvider>
                <ScrollRestoration />
                <Scripts />
                {PROD &&
                <>
                    <script async src="https://www.googletagmanager.com/gtag/js?id=G-MJ78JB63H0"></script>
                    <script async
                        dangerouslySetInnerHTML={{ __html: `
                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());

                        gtag('config', 'G-MJ78JB63H0');
                    ` }}
                    ></script>

                </>
                }
            </body>
        </html>
    );
}

export default function App() {
    const navigation = useNavigation();
    const { openMenu, setOpenMenu } = useContext(SearchContext);
    return (
        <div className="page">
                <Header />
                {navigation.state !== "idle" ?
                    <main className="loading">
                        <CircularProgress />
                        <p>Cargando...</p>
                    </main>
                    :
                    <Outlet />
                }
                <Footer />
            {openMenu && <div className="overlay" onClick={() => setOpenMenu(false)} ></div>}
        </div>
    )
}

export function ErrorBoundary({ error }) {
    let details = "Lo sentimos, ocurrió algo inesperado.";
    let desc = "Intenta recargar la página.";
    if (isRouteErrorResponse(error)) {
        if (error.status === 404) {
            details = "Lo sentimos, esa página no existe.";
            desc = "";
        }
    }

    return (
        <div className="page">
            <Header />
            <main className="error">
                <h3>{details}</h3>
                <p>{desc}</p>
            </main>
            <Footer />
        </div>
    );
}

export function HydrateFallback() {
  return (
      <div className="page">
          <Header />
          <main className="loading">
              <CircularProgress />
              <p>Cargando...</p>
          </main>
          <Footer />
      </div>
  );
}



